<ng-container [formGroup]="form">
  @if (form.controls.id?.value ?? false) {
    <p><strong>Attention:</strong> Vous ne devez pas modifier l'identité du salarié</p>
  }
  <div class="flex gap wrap">
    <mat-radio-group
      formControlName="title"
      class="w-100 employee-title"
      (change)="onCivilityChange()"
      [required]="validation()"
    >
      <mat-label>Civilité</mat-label>
      @for (title of PersonTitles; track $index) {
        <mat-radio-button [value]="title" [disabled]="readOnly()">{{ title }}</mat-radio-button>
      }
    </mat-radio-group>
  </div>
  <div class="flex gap wrap">
    <mat-form-field class="w-100">
      <mat-label>Prénom</mat-label>
      <input matInput formControlName="firstname" appTitlecase required />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Nom</mat-label>
      <input matInput formControlName="lastname" appToUppercase required />
    </mat-form-field>
    @if (form.controls.title.value === 'Madame') {
      <mat-form-field class="w-100">
        <mat-label>Nom de naissance</mat-label>
        <input
          matInput
          formControlName="birthName"
          appToUppercase
          [required]="form.controls.title.value === 'Madame'"
        />
      </mat-form-field>
    }
  </div>
  <div class="flex gap wrap birth">
    <mat-form-field class="w-100">
      <mat-label>Date de naissance</mat-label>
      <input
        matInput
        [matDatepicker]="birthdatePicker"
        formControlName="birthdate"
        placeholder="JJ/MM/AAAA"
        [required]="validation()"
      />
      <mat-datepicker-toggle matIconPrefix [for]="birthdatePicker"></mat-datepicker-toggle>
      <mat-datepicker #birthdatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Ville de naissance</mat-label>
      <input matInput formControlName="birthplace" [required]="validation()" />
    </mat-form-field>
    <app-select-country
      class="w-100"
      formControlName="birthCountry"
      [label]="'Pays de naissance'"
      [required]="validation()"
    ></app-select-country>
  </div>
  <div class="flex gap wrap">
    <app-select-nationality
      class="w-100"
      formControlName="nationality"
      [label]="'Nationalité'"
      [required]="validation()"
    ></app-select-nationality>
    <mat-form-field class="w-100">
      <mat-label>Numéro de sécurité sociale</mat-label>
      <input
        matInput
        formControlName="socialSecurityNumber"
        appSsnFormatter
        [required]="validation()"
      />
      @if (form.controls.socialSecurityNumber.hasError('invalidLength')) {
        <mat-error>Le numéro de sécurité sociale doit comporter 15 caractères.</mat-error>
      }
      @if (form.controls.socialSecurityNumber.hasError('invalidControlKey')) {
        <mat-error>Le numéro ne vérifie pas la clé de contrôle.</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="flex gap wrap">
    <div class="w-100"></div>
    <mat-checkbox
      [checked]="withoutSecuritySocialNumber"
      [disabled]="editEmployeeDisabled"
      (change)="onWithoutSocialSecurityNumberChanged($event.checked)"
      >Salarié étranger, avec numéro non attribué</mat-checkbox
    >
  </div>

  <section>
    <h3>Adresse / Hébergement</h3>
    <div class="flex gap wrap">
      <mat-form-field class="w-100">
        <mat-label>Adresse</mat-label>
        <input matInput formControlName="address" [required]="validation()" />
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label>Code postal</mat-label>
        <input matInput formControlName="postalCode" [required]="validation()" />
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label>Ville</mat-label>
        <input matInput formControlName="city" appToUppercase [required]="validation()" />
      </mat-form-field>
    </div>
  </section>

  <div class="flex gap wrap">
    <mat-form-field class="w-100">
      <mat-label>Complément d'adresse / Identité de l'hébergeur</mat-label>
      <input matInput formControlName="additionalAddress" />
      <mat-hint>Ex: Chez M. Pierre Dupont</mat-hint>
    </mat-form-field>
  </div>
  <div class="flex gap wrap phone-email">
    <app-phone-field
      class="w-100"
      formControlName="phoneNumber"
      [strictMode]="true"
      label="Téléphone"
      [required]="validation()"
    ></app-phone-field>

    <mat-form-field class="w-100">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" [required]="validation()" />
    </mat-form-field>
  </div>
</ng-container>
